function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fec100",
  d: "M11.143 3.293c1.56.016 2.924.786 3.75 2.115.459.743.624 2.924.667 5H6.63c.056-2.033.217-4.261.641-4.957.822-1.336 2.174-2.122 3.71-2.158h.162zm7.715 3.699c-.228-3.55-3.29-6.56-6.965-6.855-.232-.02-.46-.027-.687-.031C9.2.086 7.432.71 5.946 1.969c-1.473 1.246-2.44 3.085-2.59 4.913-.027.33-.03 1.984-.027 3.588-1.462.29-2.558 1.537-2.558 3.03V27.21c0 1.71 1.438 3.097 3.215 3.097h14.227c1.777 0 3.215-1.387 3.215-3.097V13.504c-.004-1.497-1.108-2.747-2.578-3.034.02-1.556.031-3.117.008-3.478z"
})));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.ac33d892.svg";
export { ForwardRef as ReactComponent };